import {
  INewbuildingRecommendation,
  IOfferRecommendation,
  IRequestCallbackFailure,
  IRequestCallbackParams,
  IRequestCallbackSuccess,
} from '@cian/callback-widget';
// eslint-disable-next-line import/no-restricted-paths
import { requestCallback, TRequestCallbackParams } from '../../../../browser/services/callbackRequest';
import { IAddCallbackResponse } from '../../../repositories/newbuilding-calltracking/v1/add-callback';
import { IAnalyticsUser } from '../../../types/analytics';
import { TRequestCallbackOpener } from '../../../types/requestCallback';
import { trackSendCallbackRequest, trackCallbackSimilarSend } from '../tracking';

interface IRequestCallbackWithRecommendationsMeta {
  analyticsLabel: string;
  placeType: TRequestCallbackOpener;
  user: IAnalyticsUser;
}

type TRecommendation = INewbuildingRecommendation | IOfferRecommendation;
type TRequestCallbackParameters = IRequestCallbackParams<TRecommendation>;
type IRequestCallbackResult = IRequestCallbackFailure | IRequestCallbackSuccess;

export const requestCallbackWithRecommendations = async (
  parameters: TRequestCallbackParameters,
  meta: IRequestCallbackWithRecommendationsMeta,
): Promise<IRequestCallbackResult> => {
  const { analyticsLabel, user, placeType } = meta;

  const extra = {
    call_now: Boolean(parameters.callRightNow),
    call_time: parameters.time,
    phone: parameters.customerPhone,
  };

  const params: TRequestCallbackParams = {
    agentPhone: parameters.agentPhone,
    callRightNow: parameters.callRightNow,
    customerPhone: parameters.customerPhone,
    time: parameters.time,
  };

  const result = await requestCallback(params);
  const isSuccessResult = typeof (result as IAddCallbackResponse).date === 'string';

  trackSendCallbackRequest({
    label: analyticsLabel,
    placeType,
    user: { ...user, extra },
  });

  if (isSuccessResult && parameters.recommendations) {
    const requestCallbackPromises: Promise<void>[] = [];

    parameters.recommendations.forEach((item, index) => {
      const position = index + 1;

      const recommendationParams: TRequestCallbackParams = {
        agentPhone: item.agentPhone,
        callRightNow: item.callRightNow,
        customerPhone: item.customerPhone,
        time: item.time,
      };

      const callPromise = requestCallback(recommendationParams)
        .then(() => {
          trackCallbackSimilarSend({
            label: analyticsLabel,
            placeType,
            user: { ...user, extra: { ...extra, call_time: item.time } },
            newbuildingId: (item.data as INewbuildingRecommendation).newbuildingId,
            position,
          });
        })
        .catch(() => {});

      requestCallbackPromises.push(callPromise);
    });

    await Promise.all(requestCallbackPromises);
  }

  return result as IRequestCallbackResult;
};
